import type { ViewQueryRecordNode } from '@salescore/core'

import { getInnerRecordNodePure, getRecordNodeFromRootNodePure } from '../../state/nodeUtility'
import type { DeepReadonly } from '../types/DeepReadonly'

export function getParentRecord(
  rootRecordNode: DeepReadonly<ViewQueryRecordNode>,
  nodePath: DeepReadonly<string[]>,
  innerRowIndex: number,
): ViewQueryRecordNode | undefined {
  if (nodePath.length === 1) {
    throw new Error(`parent of rootRecordNode must not exist`)
  }

  const parentDepthRecords = getRecordNodeFromRootNodePure(rootRecordNode, nodePath.slice(0, -1))

  if (parentDepthRecords === undefined) {
    throw new Error(`parentDepthRecords must exist`)
  }
  if (!Array.isArray(parentDepthRecords)) {
    if (nodePath.length !== 2) {
      // getRecordNodeFromRootNodeの呼び出し時、nodePath.lengthは1少なくなる。
      //  getRecordNodeの呼び出し時にもlengthが1少なくなる。
      //  getRecordNodeは再帰呼び出しになっているので、nodePathがlengthが2の時だけ戻り値が配列にならない。
      // 対して、lengthが1の時は冒頭でエラーになるので、ここに入るのはlengthが3以上の時。
      // つまり「parentDepthRecordsが配列ではない」と「nodePath.lengthが3以上」は同時に起こらないため、
      //  ここには絶対に来ないはず。
      throw new Error(`parentDepthRecords must be array`)
    }
    return parentDepthRecords
  }

  return getInnerRecordNodePure(parentDepthRecords, innerRowIndex)
}
